export default "__VITE_ASSET__LpclJp52__"